/**
 * Постеры фильмов/сериалов для карусели paywall.
 * Источник: new-paywall/films_files
 */
export const FILM_POSTERS = [
  '/films/millionPoster-C-tCM7mR.webp',
  '/films/theResidencePoster-DDWkFLj6.webp',
  '/films/squidgamePoster-b6NYyOlU.webp',
  '/films/adolescencePoster-CZZiMQ9f.webp',
  '/films/deadpoolPoster-Cnu_AzZk.webp',
  '/films/mickey17Poster-DSFclTVw.webp',
  '/films/blackBagPoster-BIHBkBW9.webp',
  '/films/brigetovPoster-D-e4fexX.webp',
  '/films/companionPoster-CdRKy-VW.webp',
  '/films/denofThievesPoster-DXSG4WCZ.webp',
  '/films/devilMayCryPoster-DEKJHk_S.webp',
  '/films/huntingPartyPoster-CJcVe6wJ.webp',
  '/films/missionimpossiblePoster-DjO1Kkl6.webp',
  '/films/nezhaPoster-CaZ31qN4.webp',
  '/films/severancePoster-ICicdNkZ.webp',
] as const;

export const BENEFIT_ICONS = {
  device: '/films/device_icon-CdMLikiU.svg',
  flash: '/films/flash_icon-C_GnvU4B.svg',
} as const;
